import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface EmailPreferencesStatus {
  email: string;
  billingEmailsEnabled: boolean;
}

export interface EmailPreferencesUpdateResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class EmailPreferencesApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/email-preferences`;

  /**
   * Get email preferences status for a given email
   */
  getStatus(email: string): Observable<EmailPreferencesStatus> {
    return this.http.get<EmailPreferencesStatus>(
      `${this.apiUrl}/${encodeURIComponent(email.toLowerCase())}`
    );
  }

  /**
   * Subscribe to billing emails
   */
  subscribe(email: string): Observable<EmailPreferencesUpdateResponse> {
    return this.http.post<EmailPreferencesUpdateResponse>(`${this.apiUrl}/subscribe`, {
      email: email.toLowerCase(),
    });
  }

  /**
   * Unsubscribe from billing emails
   */
  unsubscribe(email: string): Observable<EmailPreferencesUpdateResponse> {
    return this.http.post<EmailPreferencesUpdateResponse>(`${this.apiUrl}/unsubscribe`, {
      email: email.toLowerCase(),
    });
  }
}

